import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconProp } from "@fortawesome/fontawesome-svg-core";

@Component({
  selector: 'app-info-widget',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './info-widget.component.html',
  styleUrl: './info-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoWidgetComponent {
  @Input() title!: string;
  @Input() icon!: IconProp;
}
